import InfoIcon from "@mui/icons-material/InfoOutlined";
import { Button, Typography } from "@mui/material";
import { ReactNode } from "react";
import { EmptyStateFrame, EmptyStateIcon } from "./EmptyState";

interface CenteredMessageBoxProps {
  message: string;
  action?: {
    label: string;
    onClick: () => void;
    icon?: ReactNode;
    disabled?: boolean;
  };
}

/**
 * "Nothing here yet, and here is where to go" — the empty state shared by the
 * configuration sections.
 *
 * Styled to match the analytics prerequisite checklist, which says the same
 * kind of thing on the other side of the case: guidance about setup, not a
 * warning about something being wrong. The previous orange-bordered pill read
 * as an error and sat oddly next to the checklist a click away.
 */
const CenteredMessageBox = ({ message, action }: CenteredMessageBoxProps) => (
  // stands in for the whole section, so it fills the area rather than hugging
  // the top of it like the in-page empty states do
  <EmptyStateFrame minHeight="50vh">
    <EmptyStateIcon icon={<InfoIcon />} />

    <Typography
      variant="body1"
      sx={{
        color: "text.secondary",
        textAlign: "center",
        textWrap: "pretty",
      }}
    >
      {message}
    </Typography>

    {action && (
      <Button
        variant="contained"
        onClick={action.onClick}
        startIcon={action.icon}
        disabled={action.disabled}
      >
        {action.label}
      </Button>
    )}
  </EmptyStateFrame>
);

export default CenteredMessageBox;
